import { FFmpeg } from '@ffmpeg/ffmpeg';

let sharedFFmpegInstance: FFmpeg | null = null;
let loadingPromise: Promise<FFmpeg> | null = null;

/**
 * 获取或创建FFmpeg实例
 * @returns 初始化的FFmpeg实例
 */
export const getFFmpegInstance = async (): Promise<FFmpeg> => {
  if (loadingPromise) {
    return loadingPromise;
  }

  if (sharedFFmpegInstance && sharedFFmpegInstance.loaded) {
    return sharedFFmpegInstance;
  }

  if (sharedFFmpegInstance && !sharedFFmpegInstance.loaded) {
    await sharedFFmpegInstance.terminate();
    sharedFFmpegInstance = null;
  }

  loadingPromise = (async () => {
    const ffmpeg = new FFmpeg();

    // ffmpeg.on('log', ({ message }) => {
    //   console.log(message);
    // });

    const assetPrefix = window?.__NEXT_DATA__?.assetPrefix
      ? `${window.__NEXT_DATA__.assetPrefix}/_next/static`
      : '';

    // const baseURL = 'https://unpkg.com/@ffmpeg/core@0.12.10/dist/umd';
    await ffmpeg.load({
      // coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, 'text/javascript'),
      // wasmURL: await toBlobURL(`${baseURL}/ffmpeg-core.wasm`, 'application/wasm'),
      coreURL: `${assetPrefix}/media/ffmpeg-core.js`,
      wasmURL: `${assetPrefix}/media/ffmpeg-core.wasm`,
    });

    sharedFFmpegInstance = ffmpeg;
    loadingPromise = null;
    return ffmpeg;
  })();

  return loadingPromise;
};

export const releaseFFmpegInstance = async (): Promise<void> => {
  if (sharedFFmpegInstance) {
    // 终止Web Worker并释放资源
    try {
      await sharedFFmpegInstance.terminate();
      sharedFFmpegInstance = null;
      loadingPromise = null;
    } catch (error) {
      console.error('Error terminating FFmpeg instance:', error);
    }
  }
};
